import type { Capability } from '@taler/api-client'

/** List/get/create/delete all gate on this. The page and the nav both call it. */
export function canViewContacts(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}

/** Renaming or editing notes touches no account, so it stays on the create/view capability. */
export function canEditContact(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}

/**
 * Deleting a contact archives its backing accounts, which additionally requires
 * `ACCOUNT_ARCHIVE` (OWNER-only) server-side even though `RECORDS_MANAGE` alone covers
 * create/read/delete as an operation - a PARTNER can create and view contacts but cannot
 * delete one that has ever touched a currency. Every contact has at least one backing
 * account from creation (the ledger's base currency, provisioned eagerly), so this is not
 * a rare edge case: gate the control on both, or it renders for a PARTNER and reliably 403s.
 */
export function canDeleteContact(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE') && can('ACCOUNT_ARCHIVE')
}
